function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import membershipActionFactory from "./actionFactory/index.js";

// Action Types
export var FETCH_START = '@xo-union/store-membership/FETCH_START';
export var FETCH_SUCCESS = '@xo-union/store-membership/FETCH_SUCCESS';
export var FETCH_ERROR = '@xo-union/store-membership/FETCH_ERROR';
export var SIGN_UP_START = '@xo-union/store-membership/SIGN_UP_START';
export var SIGN_UP_SUCCESS = '@xo-union/store-membership/SIGN_UP_SUCCESS';
export var SIGN_UP_ERROR = '@xo-union/store-membership/SIGN_UP_ERROR';
export var LOG_IN_START = '@xo-union/store-membership/LOG_IN_START';
export var LOG_IN_SUCCESS = '@xo-union/store-membership/LOG_IN_SUCCESS';
export var LOG_IN_ERROR = '@xo-union/store-membership/LOG_IN_ERROR';
export var LOG_OUT_START = '@xo-union/store-membership/LOG_OUT_START';
export var LOG_OUT_SUCCESS = '@xo-union/store-membership/LOG_OUT_SUCCESS';
export var LOG_OUT_ERROR = '@xo-union/store-membership/LOG_OUT_ERROR';
export var CLEAR_ERROR = '@xo-union/store-membership/CLEAR_ERROR';

// Action creators
export var signUp = membershipActionFactory({
  progress: SIGN_UP_START,
  success: SIGN_UP_SUCCESS,
  error: SIGN_UP_ERROR
}, function (m, params) {
  return m.signUp(params);
});
export var getMember = membershipActionFactory({
  progress: FETCH_START,
  success: FETCH_SUCCESS,
  error: FETCH_ERROR
}, function (m) {
  return m.getMember();
});
export var logIn = membershipActionFactory({
  progress: LOG_IN_START,
  success: LOG_IN_SUCCESS,
  error: LOG_IN_ERROR
}, function (m, params) {
  return m.logIn(params);
});
export var logOut = membershipActionFactory({
  progress: LOG_OUT_START,
  success: LOG_OUT_SUCCESS,
  error: LOG_OUT_ERROR
}, function (m) {
  return m.logOut();
});
export var clearError = function clearError(errorType) {
  return {
    type: CLEAR_ERROR,
    errorType: errorType
  };
};

// Reducer Initial State
export var initialState = {
  member: null,
  errors: {},
  inProgress: {
    FETCH: false,
    SIGN_UP: false,
    SIGN_IN: false
  }
};
var handleStateStarting = function handleStateStarting(state, action, dataKey) {
  return _objectSpread(_objectSpread({}, state), {}, {
    inProgress: _objectSpread(_objectSpread({}, state.inProgress), {}, _defineProperty({}, dataKey, true))
  });
};
var handleStateStoreMember = function handleStateStoreMember(state, action, dataKey) {
  return _objectSpread(_objectSpread({}, state), {}, {
    analyticsProperties: action.payload.analyticsProperties || null,
    member: action.payload.member || null,
    addresses: action.payload.addresses || null,
    session: action.payload.session || null,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, dataKey, null)),
    inProgress: _objectSpread(_objectSpread({}, state.inProgress), {}, _defineProperty({}, dataKey, false))
  });
};
var handleStateError = function handleStateError(state, action, dataKey) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, dataKey, action.error)),
    inProgress: _objectSpread(_objectSpread({}, state.inProgress), {}, _defineProperty({}, dataKey, false))
  });
};

// Reducer
export var membershipReducer = function membershipReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    //
    // Initial Actions
    //
    case FETCH_START:
      return handleStateStarting(state, action, 'FETCH');
    case SIGN_UP_START:
      return handleStateStarting(state, action, 'SIGN_UP');
    case LOG_IN_START:
      return handleStateStarting(state, action, 'LOG_IN');
    case LOG_OUT_START:
      return handleStateStarting(state, action, 'LOG_OUT');
    //
    // Successful Actions
    //
    case FETCH_SUCCESS:
      return handleStateStoreMember(state, action, 'FETCH');
    case SIGN_UP_SUCCESS:
      return handleStateStoreMember(state, action, 'SIGN_UP');
    case LOG_IN_SUCCESS:
      return handleStateStoreMember(state, action, 'LOG_IN');
    case LOG_OUT_SUCCESS:
      return handleStateStoreMember(state, action, 'LOG_OUT');
    //
    // Error actions
    //
    case FETCH_ERROR:
      return handleStateError(state, action, 'FETCH');
    case SIGN_UP_ERROR:
      return handleStateError(state, action, 'SIGN_UP');
    case LOG_IN_ERROR:
      return handleStateError(state, action, 'LOG_IN');
    case LOG_OUT_ERROR:
      return handleStateError(state, action, 'LOG_OUT');
    //
    // Other Actions
    //
    case CLEAR_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.errorType, null))
      });
    default:
      return state;
  }
};

//
// Selectors
//
export var selectMemberID = function selectMemberID(state) {
  var member = state.membership.member;
  return member && member.id;
};
export var selectMember = function selectMember(state) {
  var member = state.membership.member;
  return member;
};
export var selectIsLoggedIn = function selectIsLoggedIn(state) {
  return !!selectMember(state);
};
export var createErrorSelector = function createErrorSelector(formType) {
  return function (state) {
    return state.membership.errors[formType];
  };
};
export var createInProgressSelector = function createInProgressSelector(formType) {
  return function (state) {
    return state.membership.inProgress[formType];
  };
};

/**
 * @deprecated Prefer selectMemberID
 */
export var getMemberId = selectMemberID;